import { useState } from "react";
import { useQuery } from "@apollo/client";
import queries from "Shared/queries";
import { AssociatedLocationsQuery, AssociatedLocationsQueryVariables } from "generated/graphql";

const LOCATIONS_PER_PAGE = 100;

export const useLocationSearch = () => {
  const [locationSearchOptions, setLocationSearchOptions] = useState({
    searchTerm: "",
    page: 1,
  });

  const { data: searchData, loading } = useQuery<AssociatedLocationsQuery, AssociatedLocationsQueryVariables>(
    queries.GET_ASSOCIATED_LOCATIONS,
    {
      variables: {
        search: locationSearchOptions.searchTerm,
        page: locationSearchOptions.page,
        perPage: LOCATIONS_PER_PAGE,
      },
    }
  );

  const increasePage = () => {
    setLocationSearchOptions({
      ...locationSearchOptions,
      page: locationSearchOptions.page + 1,
    });
  };

  const setSearchTerm = (newSearchTerm: string) => {
    setLocationSearchOptions({
      searchTerm: newSearchTerm,
      page: 1,
    });
  };

  return {
    totalCount: searchData?.employer.associatedLocations.totalCount || 0,
    locations: searchData?.employer.associatedLocations.items || [],
    searchTerm: locationSearchOptions.searchTerm,
    setSearchTerm,
    increasePage,
    loading,
  };
};
